export default function FormulaColumnRenderer(params) {
  return (
    `<div
        class="d-flex align-items-center"
      >
        ${params.value ?? ""}
      </div>`
  );
}